import { TextVerticalSpacer } from '@superhi/design'
import styled from 'styled-components'

export const Wrapper = styled(TextVerticalSpacer).attrs({ level: '2' })`
  display: flex;
  align-items: center;
  flex-direction: column;
`
